<div class="mt-2">
  <div class="row">
    <div class="col-md-9 mt-3 w-100">
      <h4 class="title"><i class="fas fa-trash"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-3 mt-3 content-position-end">
      <div ngbDropdown class="d-inline-block custom-button">
        <button class="btn btn-outline-success custom-button font-weight-bold mw-180 custom-button" id="dropdownForm1" ngbDropdownToggle>
          <i class="fa fa-plus" aria-hidden="true"></i> {{ "BUTTON.MORE-ACTIONS" | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <a ngbDropdownItem class="{{isEmptySelectedList?'disabled':''}}"
             *ngIf="true"
             (click)="openModalDeleteBatch()">
            <i class="fa fa-trash-alt"></i> {{ "TITLE.DELETE-DOCUMENTS-IN-BATCH" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="row mt-2">
    <div class="col-md-2 custom-col-md">
      <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadEnterprises()">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3 custom-col-md">
      <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="enterpriseSelected"
                (ngModelChange)="reloadWorkflows()">
          <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 custom-col-md">
      <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-code-branch"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="workflowSelected"
                (ngModelChange)="reloadDocuments()">
          <option *ngFor="let workflow of workflows" [ngValue]="workflow">{{workflow.description | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3 custom-col-md">
      <label class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-keyboard"></i></div>
        </div>
        <input type="text"
               id="searchInput"
               class="form-control"
               placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
               [(ngModel)]="term2Search"
               (keyup.enter)="search()">
      </div>
    </div>
    <div class="col-md-2 custom-col-md custom-mt-24 ">
      <button type="button"
              class="btn btn-outline-success custom-button"
              [disabled]="term2Search === undefined"
              (click)="search()">
        <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
      </button>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col">
          <div class="custom-control content-checkbox-end custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="addRemoveAllCheckbox"
                   [checked]="wasAllSelected()"
                   (click)="addOrRemoveAll($event)">
            <label class="custom-control-label" for="addRemoveAllCheckbox"></label>
          </div>
        </th>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.FLOW' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.UPLOADER' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let document of documents; let index=index" class="custom-font-size-table-body">
        <td class="" title="{{'TABLE.HEADER.SELECTED-RECORD' | translate}} {{(page.number * 10) + index + 1}}">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="addRemoveCheckbox{{index}}"
                   [checked]="wasSelected(document)"
                   (click)="addOrRemove($event, document)">
            <label class="custom-control-label" for="addRemoveCheckbox{{index}}"></label>
          </div>
        </td>
        <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
        <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}">{{document._more.enterpriseName}}</td>
        <td title="{{'TABLE.HEADER.FLOW' | translate }}">{{document._more.workflowDescription}}</td>
        <td title="{{'TABLE.HEADER.UPLOADER' | translate }}">{{document._more.uploaderName}}</td>
        <td title="{{'TABLE.HEADER.SUBJECT' | translate }}">{{document.subject}}</td>
        <td title="{{'TABLE.HEADER.DATE' | translate }}">{{document.createAt | dateformat}}</td>
        <td title="{{'TABLE.HEADER.STATE' | translate }}">{{'TABLE.HEADER.DELETED' | translate}}</td>
        <td title="{{'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <button type="button" class="btn btn-default " id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item pointer"
                 *ngIf="!wasDeleted(document) && hasDocuments(document)"
                 (click)="openModalView(document)">
                <i class="fa fa-eye"></i> {{ "BUTTON.VIEW" | translate }}
              </a>
              <a class="dropdown-item pointer"
                 *ngIf="!wasDeleted(document) && hasDocuments(document)"
                 (click)="downloadOf(document)">
                <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
              </a>
              <a class="dropdown-item pointer"
                 *ngIf="!wasDeleted(document)"
                 (click)="openModalDelete(document)">
                <i class="fa fa-trash-alt"></i> {{ "BUTTON.DELETE" | translate }}
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6" [(ngModel)]="pageNumber"
                  (ngModelChange)="reloadDocuments()">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{documents.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadDocuments(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadDocuments(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadDocuments(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadDocuments(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading
  *ngIf="(loading && !calledOfAutorefresh) || loadingSave || loadingShowBy || loadingAttend"></app-loading>
